import RuleService from '../../../../../cmms/rule/service/RuleService';
import types from './mutation-types';
import VcomProvider from '../../../../../VcomProvider';

async function loadRules({ commit }, systemIds) {
  commit(types.UPDATE_LOADING_STATE, true);

  const rules = await RuleService.getList(systemIds);
  commit(types.UPDATE_RULES, rules);

  commit(types.UPDATE_LOADING_STATE, false);
}

async function removeRule({ commit, state }, ruleToDelete) {
  commit(types.UPDATE_LOADING_STATE, true);
  await RuleService.remove(VcomProvider.adminSystemId, ruleToDelete);
  const remainingRules = state.rules.filter((rule) => rule.id !== ruleToDelete.id);
  commit(types.UPDATE_RULES, remainingRules);
  commit(types.UPDATE_LOADING_STATE, false);
}

async function loadTickets({ commit }, ruleId) {
  commit(types.UPDATE_LOADING_STATE, true);

  const tickets = await RuleService.getTicketList(ruleId);
  commit(types.UPDATE_TICKETS, tickets);

  commit(types.UPDATE_LOADING_STATE, false);
}

async function loadFrequencies({ commit }) {
  const frequencies = await RuleService.getFrequencies();
  commit(types.UPDATE_FREQUENCIES, frequencies);
}

export default {
  loadRules,
  loadFrequencies,
  loadTickets,
  removeRule,
};
